var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 96,
    viewBox: "0 0 82 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 0.5H4.30002C2.20003 0.5 0.400024 2.2 0.400024 4.4V91.7C0.400024 93.8 2.10002 95.6 4.30002 95.6H26.5C28.6 95.6 30.4 93.9 30.4 91.7V4.4C30.4 2.2 28.7 0.5 26.6 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7 0.5H55.4C53.3 0.5 51.5 2.2 51.5 4.4V91.7C51.5 93.8 53.2 95.6 55.4 95.6H77.6C79.7 95.6 81.5 93.9 81.5 91.7V4.4C81.5 2.2 79.8 0.5 77.7 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.9d86d36dd55f0a36f89fa462bc39f47d.svg";
export { ForwardRef as ReactComponent };